/**
 * Sign-up pages for readers of "Unbequem Gesund" (QR codes in the book → /buch/<slug>).
 * Add a new page: add an entry here AND the slug in supabase/functions/_shared/bookExtras.ts.
 * The ActiveCampaign tags are always "buch" and "buch-<slug>".
 */
export interface BookExtra {
  slug: string;
  title: string;
  description: string;
}

export const BOOK_EXTRAS: BookExtra[] = [
  {
    slug: 'bonus',
    title: 'Dein Bonus-Paket',
    description: 'Alle Checklisten, Vorlagen und Extras zum Buch an einem Ort. Trag dich ein und du bekommst den Zugang direkt per E-Mail.',
  },
  {
    slug: 'habits',
    title: 'Habit-Stacking-Planer',
    description: 'Dein Planer, um neue Gewohnheiten an bestehende zu koppeln, mit 30-Tage-Tracker zum Ausdrucken.',
  },
  {
    slug: 'selbsttest',
    title: 'Selbsttest: Wie alt bist du wirklich?',
    description: 'Ein kurzer Selbsttest zu deinem biologischen Alter und deiner Energie. So siehst du, wo du gerade stehst.',
  },
  {
    slug: 'schlaf',
    title: 'Schlaftagebuch-Vorlage',
    description: 'Die Vorlage, mit der du deinen Schlaf ein paar Wochen lang festhältst und Muster erkennst.',
  },
  {
    slug: 'atmung',
    title: 'Geführte Atem-Übung',
    description: 'Eine geführte Atem-Übung als Audio. Ein paar Minuten, die du überall machen kannst.',
  },
  {
    slug: 'werte',
    title: 'Werte-Arbeitsblatt',
    description: 'Das Arbeitsblatt, mit dem du klärst, was dir wirklich wichtig ist, und deine Entscheidungen daran ausrichtest.',
  },
  {
    slug: 'tagesplan',
    title: 'Dein Tagesablauf auf einer Seite',
    description: 'Der Tagesablauf aus Teil II des Buchs, kompakt auf einer Seite zum Ausdrucken.',
  },
];

export const getBookExtra = (slug?: string) => BOOK_EXTRAS.find((e) => e.slug === slug);
